import * as bootstrap from 'bootstrap';

console.log('hellow');
//data points
let myArray = [
  [10, 8],
  [50, 12],
  [100, 16],
  [500, 24],
  [1, 36],
];

//grabbing the HTML elements to be used
let myRangeSlider = document.getElementById('slider');
let myPageViews = document.getElementsByClassName('view_numbers')[0],
  myDollarAmount = document.getElementById('amount');

myRangeSlider.value = 3;
myRangeSlider.style.backgroundSize = '60% 100%';
//adding event listener to the range slider
myRangeSlider.addEventListener('input', (e) => {
  myRangeSlider.style.backgroundSize = `${
    100 * (0.2 * myRangeSlider.value)
  }% 100%`;
  changeContent();
  s;
});

function changeContent() {
  for (let i = 0; i < myArray.length; i++) {
    console.log(myArray.indexOf(myArray[i]));
    if (myRangeSlider.value == 0) {
      myPageViews.textContent = `0K PAGEVIEWS`;
      myDollarAmount.innerHTML = '$0.00';
    } else if (myRangeSlider.value - 1 === myArray.indexOf(myArray[i])) {
      if (myRangeSlider.value <= 4) {
        myPageViews.textContent = `${myArray[i][0]}K PAGEVIEWS`;
        myDollarAmount.textContent = `$${myArray[i][1]}.00`;
      } else {
        myPageViews.textContent = `${myArray[i][0]}M PAGEVIEWS`;
        myDollarAmount.textContent = `$${myArray[i][1]}.00`;
      }
    }
  }
}
//grabbbing checkbox element
let myCheckbox = document.getElementById('flexSwitchCheckDefault');
//adding eventlistener to the checkbxo
myCheckbox.addEventListener('change', (e) => {
  if (e.target.checked) {
    let myNewString = myDollarAmount.textContent.slice(1);
    myDollarAmount.textContent = `$${Number(myNewString) * 0.75}.00`;
    changeCheckedContent();
  } else if (!e.target.checked) {
    let myNewString = myDollarAmount.textContent.slice(1);
    myDollarAmount.textContent = `$${Math.round(
      Number(myNewString) * 1.33
    )}.00`;
    myRangeSlider.addEventListener('input', (e) => {
      myRangeSlider.style.backgroundSize = `${
        100 * (0.2 * myRangeSlider.value)
      }% 100%`;
      changeContent();
    });
  }
});

function changeCheckedContent() {
  myRangeSlider.addEventListener('input', (e) => {
    myRangeSlider.style.backgroundSize = `${
      100 * (0.2 * myRangeSlider.value)
    }% 100%`;
    for (let i = 0; i < myArray.length; i++) {
      console.log(myArray.indexOf(myArray[i]));
      if (myRangeSlider.value == 0) {
        myPageViews.textContent = `0K PAGEVIEWS`;
        myDollarAmount.innerHTML = '$0.00';
      } else if (myRangeSlider.value - 1 === myArray.indexOf(myArray[i])) {
        if (myRangeSlider.value <= 4) {
          myPageViews.textContent = `${myArray[i][0]}K PAGEVIEWS`;
          myDollarAmount.textContent = `$${myArray[i][1] * 0.75}.00`;
        } else {
          myPageViews.textContent = `${myArray[i][0]}M PAGEVIEWS`;
          myDollarAmount.textContent = `$${myArray[i][1] * 0.75}.00`;
        }
      }
    }
  });
}

//changing discount text according to screen size
let myDiscountText = document.getElementsByClassName('yearly_discount')[0];
if (window.innerWidth < 560) {
  console.log('hello');
  console.log(myDiscountText.textContent);
  myDiscountText.textContent = '-25%';
} else {
  myDiscountText.textContent = '25% discount';
}

//for those that are testing
window.addEventListener('resize', () => {
  if (window.innerWidth < 560) {
    console.log('hello');
    console.log(myDiscountText.textContent);
    myDiscountText.textContent = '-25%';
  } else {
    myDiscountText.textContent = '25% discount';
  }
});
